import {
  B_22,
  BANNER_DEFAULTS,
  hideB22Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B22_PLASMIC_PROPS = {
  b22Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_22].heading,
    description: "Main heading (B22 only)",
    hidden: hideB22Props,
  },
  b22Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_22].description,
    description: "Description text (B22 only)",
    hidden: hideB22Props,
  },
  b22PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_22].primaryButtonText,
    description: "Primary CTA button text (B22 only)",
    hidden: hideB22Props,
  },
  b22PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_22].primaryButtonUrl,
    description: "Primary CTA button URL (B22 only)",
    hidden: hideB22Props,
  },
  b22Image: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_22].image,
    description: "Image (B22 only)",
    hidden: hideB22Props,
  },
  b22ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_22].imageAlt,
    description: "Image alt text (B22 only)",
    hidden: hideB22Props,
  },
};
